export default __webpack_public_path__ + "static/media/description-comment.ede80f1a.png";